import { PhoneCall, MessageSquare, MapPin, Clock, User } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

export default function Contact() {
  return (
    <section id="contact" className="relative py-28 sm:py-36 bg-base grid-bg" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <SectionTag index="05" label="Operations hub" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-2xl">
            One call. <span className="text-cyan-400">Site secured.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Reveal className="space-y-4">
            <div className="bg-card border border-line rounded-2xl p-8">
              <div className="flex items-center gap-4">
                <span className="w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-400/30 flex items-center justify-center font-display font-extrabold text-xl text-cyan-300">AA</span>
                <div>
                  <p className="font-display font-bold text-lg text-strong" data-testid="owner-name">Abdulla Ansari</p>
                  <p className="text-sm text-strong0 flex items-center gap-1.5"><User className="w-3.5 h-3.5" /> Owner · Anaya CCTV Security Solutions</p>
                </div>
              </div>
              <div className="mt-7 space-y-4 text-sm">
                <p className="flex items-start gap-3 text-body">
                  <MapPin className="w-4 h-4 text-cyan-400 mt-0.5 shrink-0" />
                  Krishna Bihar Chowk, Sewa Dham Rd, Krishna Vihar, Mandoli, Ghaziabad, Uttar Pradesh 201102
                </p>
                <p className="flex items-center gap-3 text-body">
                  <Clock className="w-4 h-4 text-cyan-400 shrink-0" />
                  Opens 9:00 AM · Monday to Sunday
                </p>
                <p className="flex items-center gap-3 text-body">
                  <PhoneCall className="w-4 h-4 text-cyan-400 shrink-0" />
                  <span className="font-mono2 tracking-wider">+91 70113 64764</span>
                </p>
              </div>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:7011364764"
                  data-testid="contact-call-button"
                  className="flex-1 flex items-center justify-center gap-2.5 bg-cyan-500 hover:bg-cyan-400 text-on-accent font-display font-bold px-6 py-4 rounded-xl transition-all duration-300 hover:shadow-[0_0_35px_rgba(6,182,212,0.4)]"
                >
                  <PhoneCall className="w-5 h-5" /> Call Now
                </a>
                <a
                  href="https://wa.me/917011364764?text=Hi%20Anaya%20CCTV%2C%20I%20want%20to%20book%20a%20free%20site%20visit"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp-button"
                  className="flex-1 flex items-center justify-center gap-2.5 bg-emerald-500 hover:bg-emerald-400 text-on-accent font-display font-bold px-6 py-4 rounded-xl transition-all duration-300 hover:shadow-[0_0_35px_rgba(16,185,129,0.4)]"
                >
                  <MessageSquare className="w-5 h-5" /> WhatsApp
                </a>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="clip-frame overflow-hidden border border-line h-full min-h-[380px]" data-testid="contact-map">
              <iframe
                title="Anaya CCTV Security Solutions location"
                src="https://maps.google.com/maps?q=Anaya%20CCTV%20Security%20Solutions%20Krishna%20Vihar%20Mandoli%20Ghaziabad&t=&z=14&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full min-h-[380px] map-dark"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
